import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import DisableFormTextField from "../../_components/DisableFormTextField";
import { useBookingSubstitutionQueryObserver } from "../../../../api/services";
import { RouteParams } from "../../../../types";

const BookingOwner = () => {
    const { t } = useTranslation('booking');

    const { id } = useParams<RouteParams>();

    const substitutionQuery = useBookingSubstitutionQueryObserver(id);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography variant="h5">
                        {t('label.bookingOwner')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    { substitutionQuery.data?.raData?.bookingOwner &&
                        <>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.id" label={'label.id'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.firstName" label={'label.firstName'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.lastName" label={'label.lastName'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.birthDate" label={'label.birthDate'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.birthNation" label={'label.nationOfBirth'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.birthNation" label={'label.nationOfBirth'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.birthPlace" label={'label.placeOfBirth'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.residenceCountry" label={'label.countryOfResidence'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.fiscalCode" label={'label.fiscalCode'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.drivingLicenseNumber" label={'label.drivingLicenseNumber'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.email" label={'label.email'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.mobilePrefix" label={'label.prefix'}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DisableFormTextField name="bookingOwner.mobile" label={'label.mobile'}/>
                            </Grid>
                        </>
                    }
                    {substitutionQuery.data?.raData.bookingCompanyOwner &&
                    <>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.id" label={'label.id'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.companyName" label={'label.companyName'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.country" label={'label.country'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.city" label={'label.city'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.streetName" label={'label.streetName'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.streetNumber" label={'label.streetNumber'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.postalCode" label={'label.postalCode'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.email" label={'label.email'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.certifiedEmailAddress" label={'label.certifiedEmailAddress'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.telephone" label={'label.telephone'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.mobilePrefix" label={'label.prefix'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.mobile" label={'label.mobile'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.sdiCode" label={'label.invoiceCode'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.vatNumberCountry" label={'label.vatNumberCountry'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.vatNumber" label={'label.vatNumber'}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DisableFormTextField name="bookingOwner.fiscalCode" label={'label.fiscalCode'}/>
                        </Grid>
                    </>
                    }
                </Grid>
            </AccordionDetails>
        </Accordion >
    )
}

export default BookingOwner;
